"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * PageView - Set Page View
 * Event Tracking - Set all event tracking
 * These events are setup in GTM as well to pass the values to GA
 */
var GoogleAnalytics = {
  setPageView: function setPageView(path, title) {
    if (window && window.dataLayer) {
      return window.dataLayer.push({
        event: 'GAPageEvent',
        pagePath: path,
        pageTitle: title
      });
    }
  },
  setEventTracking: function setEventTracking(category, action, label) {
    if (window && window.dataLayer) {
      return window.dataLayer.push({
        event: 'GAevent',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
      });
    }
  },
  setOrderDataLayer: function setOrderDataLayer(id) {
    _axios["default"].get("/jsp/thirdparty/au/common/json_order_data_layer.jsp?orderId=".concat(id)).then(function (res) {
      if (window && window.dataLayer) {
        window.dataLayer.push(res.data);
      }
    })["catch"](function (err) {
      console.log(err);
    });
  }
};
var _default = exports["default"] = GoogleAnalytics;